import React from "react";
import FadeInSection from "./FadeInSection"; // Import animation wrapper
import "./DataAPIAggregatorAgent.css"; // Import the CSS file

const DataAPIAggregatorAgent = () => {
  return (
    <FadeInSection className="data-api-aggregator-container">
      <h2 className="data-api-aggregator-title">Data API Aggregator Agent</h2>

      <p className="data-api-aggregator-description">
        Automatically gathers and integrates high-confidence data into your system, ensuring that your AI solutions evolve with your data over time.
      </p>

      <div className="data-api-aggregator-grid">
        {/* Benefit 1 */}
        <div className="data-api-aggregator-item">
          <h3 className="data-api-aggregator-subtitle">Automated Data Integration</h3>
          <p className="data-api-aggregator-text">
            Collects and validates relevant data before adding it to your API.
          </p>
        </div>

        {/* Benefit 2 */}
        <div className="data-api-aggregator-item">
          <h3 className="data-api-aggregator-subtitle">Pairs with Data API Operator</h3>
          <p className="data-api-aggregator-text">
            Works seamlessly with the Data API Operator Agent to create a fully automated knowledge system.
          </p>
        </div>

        {/* Benefit 3 */}
        <div className="data-api-aggregator-item">
          <h3 className="data-api-aggregator-subtitle">Expands AI Knowledge</h3>
          <p className="data-api-aggregator-text">
            Continuously grows your database, improving AI-powered insights over time.
          </p>
        </div>
      </div>

      {/* Example Use Case Section */}
      <div className="data-api-aggregator-example">
        <h3 className="data-api-aggregator-example-title">Example Use Case</h3>
        <p className="data-api-aggregator-example-text">
          <strong>Automated Data Collection</strong> – The agent analyzes raw data sources and adds relevant information to your API only when confident in its accuracy, enabling a self-growing AI system.
        </p>
      </div>
    </FadeInSection>
  );
};

export default DataAPIAggregatorAgent;
